import { memo, useCallback, useContext, useEffect, useRef, useState } from 'react';
import AnimateTop from 'components/AnimateTop';
import BaseInput from 'components/common/BaseInput';
import Footer from 'components/footer/Footer';
import { FooterOkBtn } from 'components/footer/Footer.styled';
import StepLayout from 'components/layout/StepLayout';
import { Form, Formik } from 'formik';
import { useSelector, useDispatch } from 'react-redux';
import { fillStep8Data, sendForm } from 'store/slices/form.slice';
import { nextStep, prevStep } from 'store/slices/global.slice';
import { VALIDATION_STEP_8 } from 'utils/validations';
import { Step8Content } from './Step8.styled';
import { UserFormContext } from 'components/UserForm';
import ProgressLoader from 'components/progress-loader/ProgressLoader';
import Stripe from './Stripe';

const Step8 = () => {
  const { comment, loading } = useSelector((state) => state.form);
  const [isCCAccepted, setIsCCAccepted] = useState(false);
  const { insFront, insBack, labOrders, dateData } =
    useContext(UserFormContext);
  const dispatch = useDispatch();
  const commentRef = useRef(null);

  const onSubmitStep8 = useCallback(
    async (values) => {
      await dispatch(fillStep8Data(values));

      await dispatch(
        sendForm({
          insuranceFront: insFront,
          insuranceBack: insBack,
          labOrders: labOrders,
          date1: dateData.date1,
          date2: dateData.date2,
          date3: dateData.date3,
        })
      );
      await dispatch(nextStep());
    },
    [dispatch, dateData, insFront, insBack, labOrders]
  );

  useEffect(() => {
    if (commentRef.current && window.innerWidth > 768)
      commentRef.current.focus();
  }, [commentRef]);

  const onConfirmCC = (clientSecret, paymentIntent)=>{
    alert(clientSecret);
    alert(paymentIntent);
    //localStorage.setItem("secret", clientSecret);
    localStorage.setItem("intent", clientSecret);
    /*data.clientSecret = clientSecret;
    data.paymentIntent = paymentIntent;*/
    setIsCCAccepted(true);
  }

  return (
    <AnimateTop y={window.innerWidth < 768 ? '150px' : '100%'}>
      {!loading ? (
        <>
          <div style={{ maxWidth: '625px' }}>
            <StepLayout title={(!isCCAccepted?"Estimated service cost":"Excellent. Any additional information or comments you can share in advance will help us expedite your order.Do you have any comments or concerns you would like to add?")} >
              {
                !isCCAccepted&&(
                  <Stripe onConfirm={(clientSecret, paymentIntent)=>onConfirmCC(clientSecret, paymentIntent)} />
                )
              }
              {
                isCCAccepted && (
                <Formik
                  initialValues={{
                    comment: comment,
                  }}
                  validationSchema={VALIDATION_STEP_8}
                  onSubmit={onSubmitStep8}
                >
                  <Form>
                    <Step8Content>
                      <BaseInput
                        name='comment'
                        placeholder='Type your answer here...'
                        ref={commentRef}
                      />
                    </Step8Content>
                    <Footer prevArrowClick={() => dispatch(prevStep())}>
                      <FooterOkBtn type='submit'>Submit</FooterOkBtn>
                    </Footer>
                  </Form>
                </Formik>
                )
              }
            </StepLayout>
          </div>
        </>
      ) : (
        <>
          <ProgressLoader />
        </>
      )}
    </AnimateTop>
  );
};

export default memo(Step8);
